define('views/filefinder/Podio.Views.FileFinder',['require','underscore','jquery','lib/backbone/Backbone.PodioView','lib/Podio.UI','lib/Podio.Config','jst!filefinder/filefinder','jst!filefinder/sharefile_limited_filefinder','jst!filefinder/_tab_error'],function(require) {

  var _ = require('underscore');
  var $ = require('jquery');
  var ViewPodioBase = require('lib/backbone/Backbone.PodioView');
  var podioUI = require('lib/Podio.UI');
  var podioConfig = require('lib/Podio.Config');

  var jstFilefinder = require('jst!filefinder/filefinder');
  var sfLimitedFileFinder = require('jst!filefinder/sharefile_limited_filefinder');
  var jstTabError = require('jst!filefinder/_tab_error');

  return ViewPodioBase.extend({
    podioEvents : {
      'click .file-finder .footer .done'   : 'onDoneButtonClick',
      'click .file-finder .footer .cancel' : 'onCancelButtonClick',
    },

    shortcuts  : {
      'block esc' : 'onShortcutEscPressed'
    },

    initialize : function(options) {
      _.bindAll(this, 'render', 'hideOptionsButton', 'showOptionsButton');

      this._super();

      this.elm = $(this.el);
      this.eventBridge = options.eventBridge;

      this.eventBridge.on('fileFinder:button:enable', this.enableDoneButtonWithoutLoader.bind(this));
      this.eventBridge.on('fileFinder:button:disable', this.disableDoneButtonWithoutLoader.bind(this));
    },

    render : function() {

      var fileFinderTemplate = podioConfig.user.from_sharefile
        ? sfLimitedFileFinder
        : jstFilefinder;

      this.elmFileFinder = $(this.getTemplate(fileFinderTemplate, {
        item : this.model,
        onlyPodioFiles: this.options.onlyPodioFiles,
      }));

      this.elm.html(this.elmFileFinder);

      $('body').append(this.elm);

      var elmContent = this.elm.find('.file-finder > .content');
      podioUI.limitTabbingToElement( elmContent );

      // disable the `Done` button by default
      this.disableDoneButtonWithoutLoader();

      return this;
    },

    renderError : function(message) {
      this.elmFileFinder.find('.file-finder-content .inner').append(this.getTemplate(jstTabError, {
        message    : message,
        identifier : '',
        showButton: false
      }));
    },

    clearErrors: function() {
      this.elmFileFinder.find('.file-finder-content .inner > .message-wrapper').remove();
    },

    dispose: function() {
      this.eventBridge.unbind();

      this.remove();
    },

    minimize: function() {
      this.elmFileFinder.find('.file-finder-content').addClass('minimized');
    },

    showUploadingLoader: function() {
      this.elmFileFinder.find('.file-finder-content').addClass('uploading');
    },

    hideUploadingLoader: function() {
      this.elmFileFinder.find('.file-finder-content').removeClass('uploading');
    },

    hideOptionsButton : function() {
      this.elmFileFinder.find('.footer .options').addClass('hidden');
    },

    showOptionsButton : function() {
      this.elmFileFinder.find('.footer .options').removeClass('hidden');
    },

    enableDoneButton: function() {
      podioUI.restoreButtonWithLoader(this.elmFileFinder.find('.footer .done'));
    },

    disableDoneButton: function() {
      podioUI.disableButtonWithLoader(this.elmFileFinder.find('.footer .done'));
    },

    enableDoneButtonWithoutLoader: function() {
      podioUI.restoreInputField(this.elmFileFinder.find('.footer .done'));
    },

    disableDoneButtonWithoutLoader: function() {
      podioUI.disableInputField(this.elmFileFinder.find('.footer .done'));
    },

    onDoneButtonClick : function(elmTarget, e) {
      this.eventBridge.trigger('finished');
    },

    onCancelButtonClick : function(elmTarget, e) {
      e.stopPropagation();
      this.eventBridge.trigger('dispose');
    },

    onShortcutEscPressed: function(elmTarget, e) {
      e.stopPropagation();
      this.eventBridge.trigger('dispose');
    }

  });

});

